<template>
  <!-- 登录弹窗 -->
  <div class="log-modal">
    <div class="container_main">
      <div class="left_cont_img">
        <p class="logo">
          <img src="@/assets/pc/login/logo.png" alt="" />
        </p>
        <p class="title">欢迎来到</p>
        <p class="tips">大连工匠学院线上学习平台</p>
      </div>
      <div class="right_cont_box">
        <div class="content_box" v-if="showIndex == 1">
          <p class="close cursor" @click="goBack()">
            <img src="@/assets/close.png" alt="" />
          </p>
          <!-- <p class="tips_title">登录</p> -->
          <div class="tab_change flex">
            <p @click="changeTab('1')" :class="tabIndex==1?'active':''">密码登录</p>
            <p @click="changeTab('2')" :class="tabIndex==2?'active':''">验证码登录</p>
          </div>
          <!-- 账号登录 -->
          <el-form
            v-if="tabIndex==1"
            class="form_box"
            ref="form"
            :model="logInfo"
            label-width="80px"
            label-position="top"
          >
            <el-form-item label="输入账号">
              <el-input v-model="logInfo.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="输入密码">
              <el-input v-model="logInfo.password" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="输入验证码">
              <div class="code_cont flex">
                <el-input
                  v-model="logInfo.code"
                  placeholder="请输入验证码"
                ></el-input>
                <p class="code_text cursor" @click="timerLogin ? '' : getCodeLogin()">
                  {{ getCodeBtnTextLogin }}
                </p>
              </div>
            </el-form-item>
          </el-form>
          <!-- 验证码登录 -->
          <el-form
            v-if="tabIndex==2"
            class="form_box"
            ref="form"
            :model="loginCode"
            label-width="80px"
            label-position="top"
          >
            <el-form-item label="输入手机号">
              <el-input v-model="loginCode.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="输入验证码">
              <div class="code_cont flex">
                <el-input
                  v-model="loginCode.code"
                  placeholder="请输入验证码"
                ></el-input>
                <p class="code_text cursor" @click="timerLogin ? '' : getCodeLogin()">
                  {{ getCodeBtnTextLogin }}
                </p>
              </div>
            </el-form-item>
          </el-form>
          <p class="tips cursor" @click="showIndex = 3">忘记密码?</p>
          <div class="login_btn cursor" @click="logBtn()">登录</div>
          <div class="go_reign cursor" @click="showIndex = 2">
            没有账号？去注册>
          </div>
        </div>
        <div class="content_box content_box_zc" v-if="showIndex == 2">
          <p class="close cursor" @click="goBack()">
            <img src="@/assets/close.png" alt="" />
          </p>
          <p class="tips_title">注册</p>
          <el-form
            class="form_box reginForm"
            ref="forgetForm"
            :model="regData"
            label-width="80px"
            label-position="top"
            :rules="registerRules"
          >
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="regData.name"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>
             <el-form-item label="身份证号" prop="idcard">
              <el-input
                v-model="regData.idcard"
                placeholder="请输入您的身份证号"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="company_id" v-if="regData.user_type !== '2'">
              <el-select
                filterable
                v-model="regData.company_id"
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                :loading="loadingSelect"
                placeholder="请输入您的所在单位"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学员身份" prop="user_role" v-if="regData.user_type === '2'">
              <el-select
                filterable
                v-model="regData.user_role"
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                :loading="loadingSelect"
                placeholder="请选择您的身份"
              >
                <el-option
                  v-for="item in getUserRoleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门" prop="department" v-if="regData.user_type !== '2'">
              <el-input
                v-model="regData.department"
                placeholder="请输入您的部门"
              ></el-input>
            </el-form-item>
            <el-form-item label="职务" prop="duty" v-if="regData.user_type !== '2'">
              <el-input
                v-model="regData.duty"
                placeholder="请输入您的职务"
              ></el-input>
            </el-form-item>
            <el-form-item label="输入手机号" prop="phone">
              <el-input v-model="regData.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="输入密码" prop="password">
              <el-input v-model="regData.password" type="password"  placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="再次输入密码" prop="confirm_password">
              <el-input
                v-model="regData.confirm_password"
                type="password"
                placeholder="请再次输入密码"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="验证码验证" prop="code">
              <div class="code_cont flex">
                <el-input
                  v-model="regData.code"
                  placeholder="请输入验证码"
                ></el-input>
                <p class="code_text cursor" @click="timer ? '' : getCode()">
                  {{ getCodeBtnText }}
                </p>
              </div>
            </el-form-item> -->
          </el-form>
          <div class="login_btn cursor" @click="regBtn('form')">注册</div>
          <div class="go_reign cursor" @click="showIndex = 1">
            已有账号？去登录>
          </div>
        </div>
        <div class="content_box" v-if="showIndex == 3">
          <p class="close cursor" @click="goBack()">
            <img src="@/assets/close.png" alt="" />
          </p>
          <p class="tips_title">忘记密码</p>
          <el-form
            class="form_box"
            ref="regForm"
            :model="regData"
            label-width="80px"
            label-position="top"
            :rules="regRules"
          >
            <el-form-item label="输入手机号" prop="phone">
              <el-input v-model="regData.phone" placeholder="输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="输入新密码" prop="new_password">
              <el-input
                v-model="regData.new_password"
                type="password"
                placeholder="输入新密码（密码必须包含大小写字母、数字和特殊符号，长度至少8位）"
              ></el-input>
            </el-form-item>
            <el-form-item label="再次输入密码" prop="confirm_password">
              <el-input
                v-model="regData.confirm_password"
                type="password"
                placeholder="再次输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码验证" prop="code">
              <div class="code_cont flex">
                <el-input
                  v-model="regData.code"
                  placeholder="请输入验证码"
                ></el-input>
                <p class="code_text cursor" @click="timer ? '' : getCode()">
                  {{ getCodeBtnText }}
                </p>
              </div>
            </el-form-item>
          </el-form>
          <div class="login_btn cursor" @click="changePass()">确认修改</div>
          <div class="go_reign cursor" @click="showIndex = 1">
            已有账号？去登录>
          </div>
        </div>
        <!-- 注册成功 -->
        <div class="content_box content_box4" v-if="showIndex == 4">
          <p class="close cursor" @click="goBack()">
            <img src="@/assets/close.png" alt="" />
          </p>
          <p class="tips_title">恭喜注册成功</p>
          <p class="tips_text">您已成功注册，请赶快登录吧</p>

          <div class="login_btn cursor" @click="showIndex = 1">去登录</div>
        </div>
        <!-- 密码修改成功 -->
        <div class="content_box content_box4" v-if="showIndex == 5">
          <p class="close cursor" @click="goBack()">
            <img src="@/assets/close.png" alt="" />
          </p>
          <p class="tips_title">修改成功</p>
          <p class="tips_text">您的密码已修改成功，请重新登录</p>

          <div class="login_btn cursor" @click="showIndex = 1">去登录</div>
        </div>
      </div>
    </div>
     <!-- 添加验证码弹窗 -->
     <el-dialog
      title="请完成验证"
      :visible.sync="captchaVisible"
      width="360px"
      append-to-body
      custom-class="captcha-dialog"
    >
      <div class="captcha-container">
        <div class="captcha-input-row">
          <div class="captcha-box" ref="captchaCanvas"></div>
          <el-input v-model="captchaCode" placeholder="请输入验证码"></el-input>
        </div>
        <div class="captcha-footer">
          <el-button type="text" @click="refreshCaptcha">看不清？换一张</el-button>
          <el-button type="primary" @click="validateCaptcha">确认</el-button>
        </div>
      </div>
    </el-dialog>

      <el-dialog
        title="身份选择"
        :visible.sync="employmentTypeDialogVisible"
        width="420px"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
      <div class="choose-type-body">
        <p class="choose-type-title">请选择你是工会会员还是非工会会员</p>
        <div class="choose-type-actions">
          <el-button type="primary" size="medium" @click="selectEmploymentType('1')">工会会员</el-button>
          <el-button type="primary" size="medium" @click="selectEmploymentType('2')">非工会会员</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Bottom",
  data() {
    return {
      loadingSelect: false,
      logoState: true,
      loginType: 1, //1、个人登录，2、企业登录
      agree: true,
      showPass: false,
      getUserRoleList:[],
      avoidTheLogin: "",
      logInfo: {
        //登录信息
        phone: "", //手机号
        password: "", //密码
        code: "", //验证码
      },
      loginCode:{
        phone:'',
        code:'',
      },
      regData: {
        phone: "",
        code: "",
        new_password: "", // 添加这个字段
        confirm_password: "", // 添加这个字段
        idcard: '',
        user_role: '',
        user_type: '1',
        company_id: '',
        department: '',
        duty: ''
      },
      registerRules: {
        company_id: [
          { required: true, message: "请选择单位", trigger: "change" },
        ],
        // code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idcard: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
        user_role: [{ required: true, message: "请选择身份", trigger: "change" }],
        // department: [{ required: true, message: "请输入部门", trigger: "blur" }],
        // duty: [{ required: true, message: "请输入职务", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        confirm_password: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ]
      },
      regRules: {
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        new_password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        confirm_password: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ]
      },
      phoneErr: "", //手机号错误提示
      passErr: "", //登录报错提示
      shenHeState: false,
      siteInfo: "", //网站信息
      getCodeBtnText: "获取验证码",
      timer: "", //倒计时
      companyList: [],
      tabIndex:1,//1 账号登录 2验证码登录
      // 验证码登录
      timerLogin:'',
      getCodeBtnTextLogin:'获取验证码',//
      captchaVisible: false,
      captchaCode: '',
      captchaText: '',
      currentPhoneType: '', // 用于区分是哪个手机号的验证码
      employmentTypeDialogVisible: false, // 新增：身份选择弹框可见性

    };
  },
  props: {
    showIndex: {
      type: Number,
      default: 1,
    },
  },
   watch: {
    // 新增：当进入注册页时强制弹出身份选择
    showIndex(newVal) {
      console.log(newVal,'showIndex')
      if (newVal === 2) {
        this.employmentTypeDialogVisible = true;
      }
    }
  },
  mounted() {
    if (this.showIndex == 2) {
      this.employmentTypeDialogVisible = true;
    }
    this.siteInfo = JSON.parse(localStorage.getItem("siteInfo"));
    this.getAllList();
  },
  methods: {
    ...mapMutations(["CloseLoginModal", "ShowTipModal"]), //登录弹窗
    
    selectEmploymentType(type) {
      // 传入 '1'（在岗职工）或 '2'（新就业群体）
      this.regData.user_type = type;
      // 如果选择新就业群体，清空与单位相关字段
      if (type === '2') {
        this.regData.company_id = '';
        this.regData.department = '';
        this.regData.duty = '';
      }
      if (type === '1') {
        this.regData.user_role = '';
      }
      this.employmentTypeDialogVisible = false;
    },
    // 登录方式切换
    changeTab(num){
      this.tabIndex = num
    },
   
    getAllList() {
      this.$axios.post(`/study/personal/companyList`, {}).then((res) => {
        this.companyList = res.data;
      });
      this.$axios.post(`/study/login/getUserRoleList`, {}).then((res) => {
        this.getUserRoleList = res.data;
      });
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loadingSelect = true;
        setTimeout(() => {
          this.loadingSelect = false;
          this.$axios
            .post(`/study/personal/companyList`, { name: query })
            .then((res) => {
              this.companyList = res.data;
            });
        }, 200);
      } else {
        this.$axios
          .post(`/study/personal/companyList`, { name: query })
          .then((res) => {
            this.companyList = res.data;
          });
      }
    },

    //登录
    logBtn() {
      // debugger
      if (this.loginType == 1) {
        let url = ''
        let dataInfo = ''
        if(this.tabIndex==1){
          if (!this.logInfo.phone) {
            this.$message.error("请填写手机号");
            return;
          } else {
            let reg = /^0?1[3-9][0-9]\d{8}$/;

            if (!reg.test(this.logInfo.phone)) {
              this.$message.error("请填写正确的手机号");
              return;
            }
          }
          if (!this.logInfo.password) {
            this.$message.error("请填写密码");
            return;
          }
          if (!this.logInfo.code) {
            this.$message.error("请填写验证码");
            return;
          }
          url = '/study/login/login'
          dataInfo = this.logInfo
        }else{
          if (!this.loginCode.phone) {
            this.$message.error("请填写手机号");
            return;
          } else {
            let reg = /^0?1[3-9][0-9]\d{8}$/;

            if (!reg.test(this.loginCode.phone)) {
              this.$message.error("请填写正确的手机号");
              return;
            }
          }
          if (!this.loginCode.code) {
            this.$message.error("请填写验证码");
            return;
          }
          url = '/study/login/vipLogin'
          dataInfo = this.loginCode
        }

        this.$axios.post(url, dataInfo).then((res) => {
          console.log(res, "rse");
          if (res.code == 1) {
            localStorage.setItem("auth", JSON.stringify(res.data.token));
            localStorage.setItem("userData", JSON.stringify(res.data.phone));
            localStorage.setItem("is_auth_idcard", res.data.is_auth_idcard);
            localStorage.setItem(
              "user_avater",
              JSON.stringify(res.data.image)
            );
            if (res.data.is_auth_idcard == 0) {
              this.$alert('您的重要信息不完整，请前往个人中心完善', '提示', {
                confirmButtonText: '确定',
                showClose: false, 
                callback: () => {
                  location.reload();
                  this.$router.push('/userData/account')
                  this.CloseLoginModal();
                }
              });
            }else {
              location.reload();
              this.CloseLoginModal();
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$axios.post(`/v1/login/loginCode`, this.regData).then((els) => {
          if (els.code == 0) {
            //this.logModal = false;
            this.userInfo = els.data.user;
            localStorage.setItem("auth", JSON.stringify(els.data.auth));
            localStorage.setItem("user", JSON.stringify(els.data.user));
            localStorage.setItem("userInfo", JSON.stringify(els.data.user));

            this.$axios
              .post(`/v1/px/loginRecord`, {}, { useLog: true })
              .then(() => {
                //登录记录
                if (
                  this.$route.name == "Registered" ||
                  this.$route.name == "WelcomeRegistered"
                ) {
                  this.CloseLoginModal();
                  this.$router.push("/index");
                } else {
                  this.$router.go(0); //刷新页面
                }
              });
          } else if (els.code == 2 || els.code == 3) {
            this.shenHeState = true;
          } else {
            this.ShowTipModal({
              text: els.msg, //提示弹窗内容
            });
          }
        });
      }
    },

    // 获取登录验证码
    // getCodeLogin(){
    //   if (this.loginCode.phone) {
    //     let url = "";

    //     if (this.loginType == 2) {
    //       url = `/v1/login/sendSmsCode`;
    //     }

    //     this.$axios
    //       .post(`/study/login/sendSms`, {
    //         phone: this.loginCode.phone,
    //       })
    //       .then((res) => {
    //         this.codeErr = res.msg;

    //         if (res.code == 1) {
    //           let time = 60;

    //           this.getCodeBtnTextLogin = time + "秒后再获取";
    //           this.timerLogin = setInterval(() => {
    //             time--;
    //             if (time == 0) {
    //               this.getCodeBtnTextLogin = "获取验证码";
    //               clearInterval(this.timerLogin);
    //               this.timerLogin = "";
    //             } else {
    //               this.getCodeBtnTextLogin = time + "秒后再获取";
    //             }
    //           }, 1000);
    //         }else{
    //           this.$message.error(res.msg)
    //         }
    //       });
    //   } else {
    //     this.$message.error("请输入手机号");
    //   }
    // },

    // 生成随机验证码
    generateCaptcha() {
      const canvas = document.createElement('canvas');
      canvas.width = 120;
      canvas.height = 40;
      const ctx = canvas.getContext('2d');
      
      const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let code = '';
      for (let i = 0; i < 4; i++) {
        code += chars[Math.floor(Math.random() * chars.length)];
      }
      this.captchaText = code;

      ctx.fillStyle = '#f2f2f2';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = 'bold 24px Arial';
      ctx.fillStyle = '#333';
      for (let i = 0; i < code.length; i++) {
        const x = 20 + i * 25;
        const y = 25 + Math.random() * 8;
        const rotate = (Math.random() - 0.5) * 0.3;
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rotate);
        ctx.fillText(code[i], 0, 0);
        ctx.restore();
      }

      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.strokeStyle = `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`;
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }

      return canvas;
    },

    refreshCaptcha() {
      const canvas = this.generateCaptcha();
      const captchaBox = this.$refs.captchaCanvas;
      captchaBox.innerHTML = '';
      captchaBox.appendChild(canvas);
    },

    validateCaptcha() {
      if (!this.captchaCode) {
        this.$message.error('请输入验证码');
        return;
      }
      if (this.captchaCode.toLowerCase() === this.captchaText.toLowerCase()) {
        this.captchaVisible = false;
        this.captchaCode = '';
        if (this.currentPhoneType === 'login') {
          this.sendSmsCodeLogin();
        } else {
          this.sendSmsCode();
        }
      } else {
        this.$message.error('验证码错误，请重试');
        this.refreshCaptcha();
        this.captchaCode = '';
      }
    },
    getCodeLogin() {
      const phone = this.tabIndex == 1 ? this.logInfo.phone : this.loginCode.phone;
      if (!phone) {
        return this.$message.error('请输入手机号');
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(phone)) {
        return this.$message.error('请输入正确的手机号格式');
      }
      if (this.tabIndex == 1) {
        this.loginCode.phone = this.logInfo.phone;
      }
      this.currentPhoneType = 'login';
      this.captchaVisible = true;
      this.$nextTick(() => {
        this.refreshCaptcha();
      });
    },

    getCode() {
      if (!this.regData.phone) {
        return this.$message.error('请输入手机号');
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.regData.phone)) {
        return this.$message.error('请输入正确的手机号格式');
      }
      this.currentPhoneType = 'reg';
      this.captchaVisible = true;
      this.$nextTick(() => {
        this.refreshCaptcha();
      });
    },
    // 发送短信验证码（登录）
    sendSmsCodeLogin() {
      this.$axios.post(`/study/login/sendSms`, {
        phone: this.loginCode.phone,
      }).then((res) => {
        if (res.code == 1) {
          let time = 60;
          this.getCodeBtnTextLogin = time + "秒后再获取";
          this.timerLogin = setInterval(() => {
            time--;
            if (time == 0) {
              this.getCodeBtnTextLogin = "获取验证码";
              clearInterval(this.timerLogin);
              this.timerLogin = "";
            } else {
              this.getCodeBtnTextLogin = time + "秒后再获取";
            }
          }, 1000);
        } else {
          this.$message.error(res.msg)
        }
      });
    },

    // 发送短信验证码（注册/忘记密码）
    sendSmsCode() {
      this.$axios.post(`/study/login/sendSms`, {
        phone: this.regData.phone,
      }).then((res) => {
        if (res.code == 1) {
          let time = 60;
          this.getCodeBtnText = time + "秒后再获取";
          this.timer = setInterval(() => {
            time--;
            if (time == 0) {
              this.getCodeBtnText = "获取验证码";
              clearInterval(this.timer);
              this.timer = "";
            } else {
              this.getCodeBtnText = time + "秒后再获取";
            }
          }, 1000);
        } else {
          this.$message.error(res.msg)
        }
      });
    },
    // 获取验证码
    // getCode() {
    //   console.log("ddk");
    //   if (this.regData.phone) {
    //     let url = "";

    //     if (this.loginType == 2) {
    //       url = `/v1/login/sendSmsCode`;
    //     }

    //     this.$axios
    //       .post(`/study/login/sendSms`, {
    //         phone: this.regData.phone,
    //       })
    //       .then((res) => {
    //         this.codeErr = res.msg;

    //         if (res.code == 1) {
    //           let time = 60;

    //           this.getCodeBtnText = time + "秒后再获取";
    //           this.timer = setInterval(() => {
    //             time--;
    //             if (time == 0) {
    //               this.getCodeBtnText = "获取验证码";
    //               clearInterval(this.timer);
    //               this.timer = "";
    //             } else {
    //               this.getCodeBtnText = time + "秒后再获取";
    //             }
    //           }, 1000);
    //         }else{
    //           this.$message.error(res.msg)
    //         }
    //       });
    //   } else {
    //     this.$message.error("请输入手机号");
    //   }
    // },
    //注册按钮
    regBtn(formName) {
      if(!this.regData.idcard){
        return this.$message.error('请输入您的身份证号')
      }
      if (this.regData.user_type === '1') {
        if(!this.regData.company_id){
          return this.$message.error('请选择单位')
        }
        // if(!this.regData.department){
        //   return this.$message.error('请输入您的部门')
        // }
        // if(!this.regData.duty){
        //   return this.$message.error('请输入您的职务')
        // }
      }
      if (this.regData.user_type === '2') { 
        if(!this.regData.user_role){
          return this.$message.error('请选择学员身份')
        }
      }
      // if(!this.regData.code){
      //   return this.$message.error('请输入验证码')
      // }
      if(!this.regData.password){
        return this.$message.error('请输入密码')
      }
      if(!this.regData.confirm_password){
        return this.$message.error('请再次输入密码')
      }
      // 添加密码格式校验
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
      if (!passwordRegex.test(this.regData.password)) {
        return this.$message.error('密码必须包含大小写字母、数字和特殊符号，长度至少8位');
      }
      
      // 校验确认密码
      if (this.regData.password !== this.regData.confirm_password) {
        return this.$message.error('两次输入的密码不一致');
      }
      if(!this.regData.phone){
        return this.$message.error('请输入手机号')
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.regData.phone)) {
        return this.$message.error('请输入正确的手机号格式');
      }
      if(!this.regData.name){
        return this.$message.error('请输入姓名')
      }
      this.$refs.forgetForm.validate((valid) => {
        if (valid) {
          this.$axios
          .post(`/study/login/register`, this.regData)
          .then((res) => {
            if (res.code == 1) {
              this.showIndex = 4;
              // this.$message.success('注册成功')
              // this.CloseLoginModal()
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
          
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });

      // this.CloseLoginModal();
      // this.$router.push("/registered");
    },

    // 修改密码
    changePass() {
      if(!this.regData.phone){
        return this.$message.error('请输入手机号')
      }
      // 添加手机号格式校验
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.regData.phone)) {
        return this.$message.error('请输入正确的手机号格式');
      }
      if(!this.regData.new_password){
        return this.$message.error('请输入密码')
      }
      // 添加密码格式校验
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
      if (!passwordRegex.test(this.regData.new_password)) {
        return this.$message.error('密码必须包含大小写字母、数字和特殊符号，长度至少8位');
      }
      
      // 校验确认密码
      if (this.regData.new_password !== this.regData.confirm_password) {
        return this.$message.error('两次输入的密码不一致');
      }
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          this.$axios.post(`/study/login/resetPassword`, this.regData).then((res) => {
            if (res.code == 1) {
              this.showIndex = 5;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    //忘记密码
    forgotPass() {
      this.CloseLoginModal();
      this.$router.push("/changePassword");
    },
    goBack() {
      this.tabIndex = 1
      if (this.$route.path == "/course/liveDetail") {
        this.CloseLoginModal();
        this.$router.push('/')
      } else {
        this.CloseLoginModal();
      }
      // this.CloseLoginModal();
      // this.$router.push('/')
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.log-modal {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  // background-color: rgba(0, 0, 0, 0.6);
  background: url("@/assets/pc/login/bgm.png") no-repeat;
  background-size: 100% 100%;
  z-index: 99;
  .container_main {
    width: 1133px;
    height: 637px;
    background: #ffffff;
    border-radius: 5px 5px 5px 5px;
    display: flex;
    align-items: center;
    position: relative;
    .left_cont_img {
      width: 748px;
      height: 100%;
      background: url("@/assets/pc/login/left_img.png") no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      p {
        color: #fff;
        text-align: center;
      }
      p.logo {
        width: 162px;
        margin: 163px auto 0;
        img {
          width: 100%;
        }
      }
      p.title {
        font-size: 30px;
        margin-top: 20px;
      }
      p.tips {
        font-size: 24px;
      }
    }
    .right_cont_box {
      flex: 1;
    }
  }
  .content_box {
    box-sizing: border-box;
    padding: 19px 46px 33px;
    p.close {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      right: 20px;
      top: 20px;
      img {
      }
    }
    p.tips_title {
      font-size: 26px;
      font-weight: 800;
      color: #333333;
    }
    //tab切换
    .tab_change{
      display: flex;
      margin-top: 20px;
      margin-bottom: 40px;
      p{
        margin-right: 60px;
        font-size: 18px;
        color: #333;
        cursor: pointer;
      }
      p.active{
        color: #0080ff;
        position: relative;
        &::after{
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 25px;
          height: 4px;
          background: #0080ff;
          border-radius: 4px;
        }
      }
      p:last-child{
        margin-right: 0;
      }
    }
    .form_box {
      margin-top: 20px;
      .el-form-item {
        margin-bottom: 10px;
      }
      p:last-chid{
        margin-right: 0;
      }
    }
    .form_box {
      box-sizing: border-box;
      margin-top: 10px;
      max-height: 440px;
      overflow-y: auto;
    }
    .reginForm {
      padding-right: 5px;
    }
    .form_box::-webkit-scrollbar {
      width: 4px; //修改滚动条宽度
    }
    .form_box::-webkit-scrollbar-thumb {
      border-radius: 8px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.05);
    }
    p.tips {
      font-size: 14px;
      color: #999999;
    }
    div.login_btn {
      width: 293px;
      height: 46px;
      background: #0080ff;
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 46px;
      color: #fff;
      font-size: 20px;
      margin-top: 20px;
    }
    .go_reign {
      text-align: center;
      margin-top: 14px;
      text-decoration-line: underline;
      font-size: 16px;
      color: #0080ff;
    }
    .code_cont {
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      padding: 0 10px 0 0;
      border-radius: 4px;
      ::v-deep .el-input {
        flex: 1;
      }
      ::v-deep .el-input__inner {
        border: none;
      }
      p.code_text {
        margin-left: 10px;
        // width: 160px;
        padding: 0 15px;
        height: 31px;
        background: #ecf5ff;
        border-radius: 5px 5px 5px 5px;
        text-align: center;
        line-height: 31px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .content_box4 {
    min-height: 220px;
    p {
      text-align: center;
    }
    p.tips_text {
      color: #999;
      margin-top: 10px;
    }
  }
}
::v-deep .el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}
.content_box_zc {
  ::v-deep .el-form-item__label {
    line-height: 30px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
  ::v-deep .el-input__inner {
    height: 34px;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  .captcha-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
}
}

.captcha-container {
    .captcha-input-row {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 15px;
      
      .captcha-box {
        width: 120px;
        flex-shrink: 0;
        canvas {
          display: block;
          cursor: pointer;
        }
      }
      .el-input {
        flex: 1;
      }
    }
    .captcha-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
.choose-type-body {
  text-align: center;
  .choose-type-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 16px;
  }
  .choose-type-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
  }
}
</style>
